import { ClothesComponentId } from '~/shared';

export const CLOTH_SECTIONS = [
	{
		name: 'Head',
		value: ClothesComponentId.HEAD,
		isVisible: false,
		isProp: false,
	},
	{
		name: 'Masks',
		value: ClothesComponentId.MASK,
		isVisible: true,
		isProp: false,
	},
	{
		name: 'Hair Styles',
		value: ClothesComponentId.HAIR,
		isVisible: true,
		isProp: false,
	},
	{
		name: 'Torsos',
		value: ClothesComponentId.TORSO,
		isVisible: false,
		isProp: false,
	},
	{
		name: 'Legs',
		value: ClothesComponentId.LEGS,
		isVisible: true,
		isProp: false,
	},
	{
		name: 'Bags and Parachutes',
		value: ClothesComponentId.BACKPACK,
		isVisible: true,
		isProp: false,
	},
	{
		name: 'Shoes',
		value: ClothesComponentId.SHOES,
		isVisible: true,
		isProp: false,
	},
	{
		name: 'Accessories',
		value: ClothesComponentId.ACCESSORIES,
		isVisible: true,
		isProp: false,
	},
	{
		name: 'Undershirts',
		value: ClothesComponentId.UNDERSHITS,
		isVisible: false,
		isProp: false,
	},
	{
		name: 'Body Armors',
		value: ClothesComponentId.ARMORS,
		isVisible: true,
		isProp: false,
	},
	{
		name: 'Decals',
		value: ClothesComponentId.DECALS,
		isVisible: true,
		isProp: false,
	},
	{
		name: 'Tops',
		value: ClothesComponentId.TOPS,
		isVisible: true,
		isProp: false,
	},
	{
		name: 'Hats',
		value: ClothesComponentId.HATS,
		isVisible: true,
		isProp: true,
	},
	{
		name: 'Glasses',
		value: ClothesComponentId.GLASSES,
		isVisible: true,
		isProp: true,
	},
	{
		name: 'Ears',
		value: ClothesComponentId.EARS,
		isVisible: true,
		isProp: true,
	},
	{
		name: 'Watches',
		value: ClothesComponentId.WATCHES,
		isVisible: true,
		isProp: true,
	},
	{
		name: 'Bracelets',
		value: ClothesComponentId.BRACELETS,
		isVisible: true,
		isProp: true,
	},
];

export const INITIAL_CLOTH_SECTION = CLOTH_SECTIONS[1];
export const INITIAL_PROP_SECTION = CLOTH_SECTIONS[12];
